import React from "react";
import CtaSecondaryRight from "../../components/buttons/CtaSecondaryRight";
import CtaPrimary from "../../components/buttons/CtaPrimary";

const ValuePropsModule = props => {
  function checkHeader(header) {
    if (header) {
      return (
        <div className="headerContainer">
          <h2>{header}</h2>
        </div>
      );
    }
  }
  function checkHeaderDescription(headerDescription) {
    if (headerDescription) {
      return <p>{headerDescription}</p>;
    }
  }

  const gridTemplateStyles = {
    gridTemplateColumns: ''
  }

  const valueProps = props.itemData.map((valueProp, i) => {
    gridTemplateStyles.gridTemplateColumns = gridTemplateStyles.gridTemplateColumns + `1fr `
    return (
      <React.Fragment key={`valueProps-${i}`}>
        <div className="vp-item">
          <div className="mobile-item-header">
            <div className="image-wrapper">
              <img
                src={valueProp.img}
                alt={valueProp.alt}
              />
            </div>
            <h3>{valueProp.title}</h3>
          </div>
          <p>{valueProp.description}</p>
          {valueProp.buttonText && <CtaSecondaryRight
            text={valueProp.buttonText}
            href={valueProp.href}
          />}
        </div>
      </React.Fragment>
    );
  });

  const valuePropsTextWrap = props.itemData.map((valueProp, i) => {
    return (
      <React.Fragment key={`valueProps-${i}`}>
        <div className="vp-item text-wrapped">
          <img
            className="lazyload"
            data-src={valueProp.img}
            alt={valueProp.alt}
          />
          <div className="text-wrapper">
            <h3>{valueProp.title}</h3>
            <p>{valueProp.description}</p>
          </div>
        </div>
      </React.Fragment>
    );
  });

  return (
    <div className='valuePropsModule_container'>
      {props.header && (
        <div>
          {checkHeader(props.header)}
          {checkHeaderDescription(props.headerDescription)}
        </div>
      )}
      <div className='valuePropsModuleContainer'style={gridTemplateStyles} >
        {props.textWrap ? valuePropsTextWrap : valueProps}
        {props.href && <CtaPrimary href={props.href} text={props.text} />}
      </div>
    </div>
  );
};

export default ValuePropsModule;
